import { memo, useCallback, useState } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Button } from "@design-system/Button/Button";
import tableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { RulesDrawer } from "@components/settings/Rules/RulesDrawer";
import { EditRuleModal } from "@components/settings/Rules/EditRuleModal";
import { ArrowCornerIcon } from "@icons";
import { RuleGroupType, TransactionRule } from "@common/types/transactionRule";
import { NormalizedDescriptionInfo } from "@common/types/normalizedDescription";
import { RuleDetailsRowData } from "../utils/historyRuleDetailsRows";

const EditRuleButton: React.FC<{
    resource?: Record<string, unknown>;
    normalizedDescriptions: NormalizedDescriptionInfo[];
}> = ({ resource, normalizedDescriptions }) => {
    const [showEdit, setShowEdit] = useState(false);
    const handleOpen = useCallback(() => setShowEdit(true), []);
    const handleClose = useCallback(() => setShowEdit(false), []);

    if (!resource?.id) {
        return null;
    }

    const rule = resource as unknown as TransactionRule;
    const isTransferRule = rule.conditions?.some((c) => c.transferDirection);
    const groupType = isTransferRule
        ? RuleGroupType.TRANSFER
        : RuleGroupType.TRANSACTION;

    return (
        <>
            <Button
                variant="primary"
                size="md"
                onClick={handleOpen}
                title="View details"
                aria-label="View details"
                iconOnly
                className={tableStyles.showOnHover}
            >
                <ArrowCornerIcon />
            </Button>
            <RulesDrawer
                open={showEdit}
                onClose={handleClose}
                headerText={`Edit ${groupType} rule`}
            >
                <EditRuleModal
                    rule={rule}
                    close={handleClose}
                    groupType={groupType}
                    normalizedDescriptions={normalizedDescriptions}
                />
            </RulesDrawer>
        </>
    );
};

export const RuleDetailsEditCell = memo(
    ({ row }: { row: { original: RuleDetailsRowData } }) => (
        <ViewTableCell captureClicks>
            <EditRuleButton
                resource={row.original.resource}
                normalizedDescriptions={row.original.normalizedDescriptions}
            />
        </ViewTableCell>
    ),
);

RuleDetailsEditCell.displayName = "RuleDetailsEditCell";
